export const QuestionTemplates = {
  path: '/question_templates',
  meta: { requiresAuth: true },
  component: () => import('layouts/MainLayout.vue'),
  children: [
    {
      path: '',
      name: 'questionTemplates',
      component: () => import('pages/questionTemplates/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'page.questionTemplates.name',
        path: '/question_templates',
      },
    },
  ],
};
